"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseInfoApi = getBaseInfoApi;
exports.getPlatformByCategoryApi = getPlatformByCategoryApi;
exports.getPlatformByDayApi = getPlatformByDayApi;
exports.getPlatformInfoApi = getPlatformInfoApi;
exports.getPlatformProductInfoApi = getPlatformProductInfoApi;
exports.merchantCategoryAllListApi = merchantCategoryAllListApi;
exports.merchantConfigInfoApi = merchantConfigInfoApi;
exports.merchantListApi = merchantListApi;
exports.merchantNotifyAPIByTest = merchantNotifyAPIByTest;
exports.merchantSwitchApi = merchantSwitchApi;
exports.merchantTransferApi = merchantTransferApi;
exports.merchantTransferEditApi = merchantTransferEditApi;
exports.merchantTypeAllListApi = merchantTypeAllListApi;
exports.merchantUpdateApi = merchantUpdateApi;
exports.merchantUpdateByNotifyAPI = merchantUpdateByNotifyAPI;
exports.merchantWarningUpdateApi = merchantWarningUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 商户分类 全部列表
 */
function merchantCategoryAllListApi() {
  return (0, _request.default)({
    url: '/admin/merchant/category/all/list',
    method: 'get'
  });
}

/**
 * 商户 列表
 */
function merchantListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/supplier/list',
    method: 'get',
    params: params
  });
}

/**
 * 店铺类型 全部列表
 */
function merchantTypeAllListApi() {
  return (0, _request.default)({
    url: '/admin/merchant/type/all/list',
    method: 'get'
  });
}

/**
 * @description 商户基本设置 -- 商户详情
 */
function getBaseInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/base/info',
    method: 'get'
  });
}

/**
 * @description 商户获得供应链商品汇总数据
 */
function getPlatformProductInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/product/count/info',
    method: 'get'
  });
}

/**
 * @description 商户获得供应链商品汇总数据
 */
function getPlatformInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/platform/count/info',
    method: 'get'
  });
}

/**
 * @description 商户 最近30天交易数据
 */
function getPlatformByDayApi() {
  return (0, _request.default)({
    url: '/admin/merchant/platform/count/day',
    method: 'get'
  });
}

/**
 * @description 商户 最近30天品类占比数据
 */
function getPlatformByCategoryApi() {
  return (0, _request.default)({
    url: '/admin/merchant/platform/count/category',
    method: 'get'
  });
}

/**
 * @description 商户基本设置 -- 提交
 */
function merchantUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/config/info/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户基本设置 通知API -- 提交
 */
function merchantUpdateByNotifyAPI(data) {
  return (0, _request.default)({
    url: '/admin/retailer/info/notify/config',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户基本设置 通知API -- 测试
 */
function merchantNotifyAPIByTest(data) {
  return (0, _request.default)({
    url: '/admin/retailer/info/notify/test',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户基本设置 预警 -- 提交
 */
function merchantWarningUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/warning/info/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description 商户基本设置 -- 配置信息
 */
function merchantConfigInfoApi() {
  return (0, _request.default)({
    url: '/admin/merchant/config/info',
    method: 'get'
  });
}

/**
 * @description 商户基本设置 -- 商户开关
 */
function merchantSwitchApi() {
  return (0, _request.default)({
    url: '/admin/merchant/switch/update',
    method: 'post'
  });
}

/**
 * @description 商户基本设置 -- 转账信息
 */
function merchantTransferApi() {
  return (0, _request.default)({
    url: '/admin/merchant/settlement/info',
    method: 'GET'
  });
}

/**
 * @description 商户基本设置 -- 转账信息编辑
 */
function merchantTransferEditApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/settlement/info/edit',
    method: 'post',
    data: data
  });
}